<template>
  <div class="login">
    <form @submit.prevent="login">
      <label for="id">아이디</label>
      <input type="id" id="id" v-model="email" />
      <label for="password" class="dep-2">패스워드</label>
      <input type="password" id="password" v-model="password" />
      <button type="submit" class="login-btn">로그인</button>
    </form>
  </div>
</template>

<script>
import {mapActions} from "vuex"

export default {
  name: 'Login',
  data() {
    let email = localStorage.getItem('grm.login.userId')
    return {
      email: email || 'jaemin.lee@gooroomee.com',
      password: '1234'
    }
  },
  methods: {
    ...mapActions('auth', ['makeLogin']),
    async login() {
      if (!this.email || !this.password) {
        return
      }

      localStorage.setItem('grm.login.userId', this.email)

      try {
        await this.makeLogin({
          email: this.email.trim(),
          password: this.password.trim()
        })
      } catch (e) {
        console.error(e)
        const errorMapping = {
          'Invalid Password': 'common.login.error.invalidPasswd',
          'Not Allowed Password': 'common.login.error.notAllowedPasswd',
          'Not found user': 'common.login.error.notFoundUser',
          'Not found user detail': 'common.login.error.notFoundUserDetail',
        }
        const errorText = errorMapping[e.message] || 'common.login.error.default'
        this.$camsAlert(this.$t(errorText))
        return
      }

      await this.$router.push(this.$route.query.redirect)
    }
  }
}
</script>

<style lang="scss" scoped>
.login {  
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #eee;

  form {
    display: flex;
    flex-direction: column;

    label {
      font-size: 14px;
      font-weight: bold;
      color: #666;
    }

    input {
      box-sizing: border-box;
      width: 300px;
      height: 40px;
      margin-top: 8px;
      padding: 0 16px;
      border-radius: 6px;
      background-color: white;      
      border: 1px solid #d5d5d5;
      font-size: 16px;

      &:focus {
        border-color: #016FF2;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }

    .dep-2 {
      margin-top: 16px;
    }

    button {
      height: 40px;
      margin-top: 20px;
      border-radius: 6px;
      background-color: #016FF2;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
